// Component statuses
export const STATUS_DEFAULT = 'default';
export const STATUS_DESTRUCTIVE = 'destructive';
export const STATUS_ERROR = 'error';
export const STATUS_GHOST = 'ghost';
export const STATUS_INFO = 'info';
export const STATUS_SUCCESS = 'success';
export const STATUS_WARNING = 'warning';
